import { render } from "./MultiselectInput.vue?vue&type=template&id=197e8592&lang=pug"
import script from "./MultiselectInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiselectInput.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__